import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";
import { Concurrent } from "../../../utils/database";

export const concurrentService = {
  async createConcurrent(token: string, newConcurrent: Concurrent) {
    try {
      await axios.post(`${BACKEND_URL}/concurrent/`, newConcurrent, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      throw error;
    }
  },
  async getConcurrents(token: string, limit: any, skip: any): Promise<Concurrent[]> {
    try {
      const response = await axios.get(`${BACKEND_URL}/concurrent/?skip=${skip}&limit=${limit}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data;
      return data.data.concurrents;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async updateConcurrent(token: string, newData: Concurrent) {
    try {
      await axios.put(`${BACKEND_URL}/concurrent/${newData.id}`, newData, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async deleteConcurrent(token: string, concurrent_id: string) {
    try {
      await axios.delete(`${BACKEND_URL}/concurrent/${concurrent_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
